var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"alert media align-items-center",class:{
		'alert-info': _vm.level == 'info',
		'alert-warning': _vm.level == 'warning',
		'alert-danger': _vm.level == 'error'
	}},[(_vm.level === 'info')?_c('font-awesome-icon',{staticClass:"mr-3",attrs:{"icon":"info-circle","size":"2x"}}):_vm._e(),(_vm.level === 'warning')?_c('font-awesome-icon',{staticClass:"mr-3",attrs:{"icon":"exclamation-triangle","size":"2x"}}):_vm._e(),(_vm.level === 'error')?_c('font-awesome-icon',{staticClass:"mr-3",attrs:{"icon":"times-circle","size":"2x"}}):_vm._e(),_c('div',{staticClass:"media-body text-left"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }